import React,{ReactElement} from "react";
import {Alert, AlertTitle} from "@mui/material";

type NonIdealStateProps = {
    message?:string|ReactElement,
    severity?: "error"|"warning"|"info"|"success",
    title:string|null,
    sx?:any
}

export function NonIdealState(props:NonIdealStateProps) {
    const severity = props.severity?props.severity:'error';
    const title = props.title??severity;
    return (<Alert severity={props.severity?props.severity:'error'} sx={props.sx??null}>
                <AlertTitle>{title}</AlertTitle>
        {props.message??(props.severity=='error'?'An error has occurred':'')}</Alert>);
}